import React, { Component } from 'react';
import { getEventsDepartment } from "../../../services/widgetsService";
import FilterByYear from "../../Common/filters/FilterByYear";
import Chart from "react-google-charts";
import { messages } from '../../../utils/language-en.json';

class EventsDepartmentWidget extends Component {
  mounted = false;
  state = {
    events: [],
    hasData: false
  }

  async componentDidMount() {
    this.mounted = true;
    this.mounted && this.getEventsDepartmentData(new Date().getFullYear());
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getEventsDepartmentData = async (year) => {
    const { data } = await getEventsDepartment(year);
    const eventsData =  [['Department', 'Events']];
    var hasData = false;

    data.events.forEach((element) => {
      if (parseInt(element.total) > 0) {
        hasData = true;

        eventsData.push(
          [element.name, parseInt(element.total)]
        )
      }
    });

    this.setState({events: eventsData});
    this.setState({hasData: hasData});
    this.setState({title: data.title});
  }

  handleYearChange = async (itemSelected) => {
    const yearSelected = (itemSelected) ? itemSelected.value: new Date().getFullYear();
    this.getEventsDepartmentData(yearSelected);
  };

  render() {
    const {
      events,
      hasData,
      title
    } = this.state;

    return (
      <div className="col-auto"> 
        <div className='DashboardList-item btn d-flex flex-column'>
          <h4><i className="fas fa-chart-pie"></i>&nbsp;{title}</h4>
          <FilterByYear handleYearChange={this.handleYearChange}/>
          { !hasData 
            ? <div className="no-data">{messages.emptydata.widgetsMessage}</div>
            : 
            <Chart
              chartType="PieChart"
              loader={<div>Loading</div>}
              data={events}
              options={{
                backgroundColor: 'transparent',
                width: '100%',
                height: 180,
                is3D: true,
              }}
            />
          }
        </div>
      </div>
    )
  }
}

export default EventsDepartmentWidget;